
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7898"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7898"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gAi0s", function(module, exports) {

$parcel$export(module.exports, "checkDate", function () { return $705f9a6296b54d52$export$a22b1a0f0805197a; });

var $8l2wg = parcelRequire("8l2wg");

var $g65ub = parcelRequire("g65ub");

var $a8V6k = parcelRequire("a8V6k");
const $705f9a6296b54d52$var$getDateString = (date)=>{
    const year = date.getUTCFullYear();
    let month = date.getUTCMonth() + 1;
    let day = date.getUTCDate();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    return `${year}-${month}-${day}`;
};
const $705f9a6296b54d52$var$getTargetDateContainer = ()=>{
    return document.getElementById("target-date");
};
const $705f9a6296b54d52$var$getTargetDate = ()=>{
    const queryString = new URLSearchParams(document.location.search);
    const dateString = queryString.get("target");
    if (!dateString) return new Date();
    return new Date(dateString);
};
const $705f9a6296b54d52$var$targetDate = $705f9a6296b54d52$var$getTargetDate();
const $705f9a6296b54d52$export$a22b1a0f0805197a = (date)=>{
    return date.getUTCFullYear() === $705f9a6296b54d52$var$targetDate.getUTCFullYear() && date.getUTCMonth() === $705f9a6296b54d52$var$targetDate.getUTCMonth() && date.getUTCDate() === $705f9a6296b54d52$var$targetDate.getUTCDate();
};
window.addEventListener("hashchange", ()=>{
    (0, $a8V6k.triggerReset)();
});
(0, $g65ub.onInit)(()=>{
    const targetDateContainer = $705f9a6296b54d52$var$getTargetDateContainer();
    targetDateContainer.dateTime = $705f9a6296b54d52$var$getDateString($705f9a6296b54d52$var$targetDate);
    targetDateContainer.textContent = new Intl.DateTimeFormat(void 0, {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
    }).format($705f9a6296b54d52$var$targetDate);
    window.addEventListener((0, $8l2wg.DATE_CHANGE_EVENT_NAME), (event)=>{
        const date = event.detail;
        $705f9a6296b54d52$var$getTargetDateContainer().classList.toggle("text-green-500", $705f9a6296b54d52$export$a22b1a0f0805197a(date));
    });
});

});


parcelRequire("gAi0s");

//# sourceMappingURL=index.875f82f2.js.map
